module.exports = __webpack_public_path__ + "static/media/return.a432aee5.svg";